import generateNumericalDropdownOptionsUtil from './generateNumericalDropdownOptionsUtil';

const DEFAULT_MAX_CHILD_AGE = 17;
const DEFAULT_MIN_CHILD_AGE = 1;

const generateChildAgeDropdownOptions = (
  {
    hasMaxAgeOfEleven,
    hasInfants,
    hasZeroAndOneAgeLabels,
    hasChildAgeBelowTwo,
  }
) => {
  const minChildAge = hasZeroAndOneAgeLabels ? 0 : DEFAULT_MIN_CHILD_AGE;
  const maxChildAge = hasMaxAgeOfEleven ? 11 : DEFAULT_MAX_CHILD_AGE;
  const childAgeOptions = generateNumericalDropdownOptionsUtil(maxChildAge, minChildAge);
  if (hasInfants && hasZeroAndOneAgeLabels) {
    childAgeOptions.splice(0, 2);
  } else if (hasInfants) {
    childAgeOptions.splice(0, 1);
  } else if (!hasZeroAndOneAgeLabels) {
    childAgeOptions.splice(0, 1, { value: '1', label: hasChildAgeBelowTwo ? '2歳未満' : '< 2' });
  }
  return childAgeOptions;
};

export default generateChildAgeDropdownOptions;
